import React from "react";
import CommunicationRow from "./CommunicationRow";
import CommunicationDetails from "./CommunicationDetails";
import { LIGHT_TEXT_COLOR } from "../../common/styles";
import { tdStyles } from "./monitorStyles";

const thStyles = Object.assign({}, tdStyles, {
    fontWeight: "normal",
    borderBottom: "1px solid rgba(0,0,0,0.07)",
    color: LIGHT_TEXT_COLOR
});

const noResultsFound = <tr><td colSpan="4" style={Object.assign({}, tdStyles, {border: "none"})}>No results found</td></tr>;

const CommunicationsTable = (props) => (
    <div style={{
        fontSize: 14,
        height: "43em",
        borderTop: "1px solid rgba(0,0,0,0.15)"
    }}>
        <div style={{
            borderBottom: "1px solid rgba(0,0,0,0.15)",
            display: "inline-block",
            height: "100%",
            overflow: "auto",
            width: "60%"
        }}>
            <table style={{width: "100%", marginTop: "0.5em"}}>
                <thead>
                <tr>
                    <th style={Object.assign({}, thStyles, {border: "none"})}>Made On</th>
                    <th style={Object.assign({}, thStyles, {border: "none"})}>By</th>
                    <th style={Object.assign({}, thStyles, {border: "none"})}>Sent To</th>
                    <th style={Object.assign({}, thStyles, {border: "none"})}>Recommended</th>
                </tr>
                </thead>
                <tbody>
                { props.communications.length === 0 ? noResultsFound :
                    props.communications.map(communication =>
                        <CommunicationRow {...communication}
                                          key={communication.id}
                                          isSelected={communication.id === props.selectedCommunication}
                                          onChange={props.onCommunicationChange} />)
                }
                </tbody>
            </table>
        </div>
        <div style={{
            backgroundColor: "rgba(0,0,0,0.05)",
            display: "inline-block",
            height: "100%",
            overflow: "auto",
            verticalAlign: "top",
            width: "40%",
            padding: 10,
            boxSizing: "border-box"
        }}>
            <CommunicationDetails communication={props.communications.find(communication => communication.id === props.selectedCommunication)} />
        </div>
    </div>
);
CommunicationsTable.propTypes = {
    communications: React.PropTypes.arrayOf(React.PropTypes.object),
    selectedCommunication: React.PropTypes.string,
    onCommunicationChange: React.PropTypes.func
};
CommunicationsTable.defaultProps = {
    communications: []
};

export default CommunicationsTable;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/CommunicationsTable.js
 **/